import React, { useContext } from "react";
import { Context } from "../../context/Context";
export default function WindowControls() {
  const { state, setState, handleUpdate } = useContext(Context);
  return (
    <div className="mt-5 w-full">
      <span className="text-sm text-gray-600 font-medium  inline-block">
        CONTROLS
      </span>
      <br />
      <div className="grid grid-cols-3 gap-5 w-full mt-3">
        {state.window.controls.map(
          ({ id, imageURL, value, selected, rounded, controls }) => (
            <div className="w-14 h-14 relative mr-3" key={id}>
              <input
                type="radio"
                id={id}
                name="controls"
                className="appearance-none transform  outline-none -translate-y-1/2 -translate-x-1/2 absolute left-1/2 top-1/2 w-14 h-14 "
                checked={selected}
                value={value}
                onChange={(e) =>
                  setState(
                    handleUpdate(e.target.value, state, ["window", "controls"])
                  )
                }
              />
              <label
                htmlFor={id}
                className="absolute top-0 left-0 hover:shadow-lg w-16 h-16 rounded-md border p-2 cursor-pointer bg-white focus:border-indigo-400 outline-none transition transition-duration-300 ease-out"
              >
                <img
                  src={imageURL}
                  alt=""
                  className="w-12 absolute bottom-0 right-0 h-10 object-cover rounded-sm"
                />
              </label>
            </div>
          )
        )}
      </div>
    </div>
  );
}
